/// <amd-module name="typeahead/core/presentation/IInputElementFocusByHumanOrScriptHandler" />

/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../../typings/thirdparty/jquery/jquery.d.ts" />
/// <reference path="../../../typings/typeahead/plugins.d.ts" />

// Handles the events when an <input> element receives focus regardless of the immediate cause, whether it was due to
// a click/tap on the element, or script execution. For example, expanding the change search wizard on flights search
// results page causes its origin <input> to be focused, despite that it is not clicked on.
export interface IInputElementFocusByHumanOrScriptHandler {
    handleInputElementFocusByHumanOrScript($inputElement: JQuery, context: IContext): void;
}

export const isInputElementFocusByHumanOrScriptHandler: IPluginIdentifier = (plugin: object): boolean => {
    return (typeof plugin === "object")
        && (typeof (plugin as IInputElementFocusByHumanOrScriptHandler).handleInputElementFocusByHumanOrScript ===
            "function");
};
